import { advertisementsService } from '@/api/services/advertisements/advertisementsService'
import skleppng from '@/assets/sklep.png'
import BigContainer from '@/components/layout/containers/BigContainer'
import PageWrap from '@/components/layout/containers/PageWrap'
import Footer from '@/components/layout/footer/Footer'
import Header from '@/components/layout/header/Header'
import { Seo } from '@/components/specific/seo/Seo'
import { Button } from '@/components/ui/common/Button'
import paths from '@/router/data/paths'
import useAuthStore from '@/store/userStore' // Assuming you have user's name in auth store
import { useQuery } from '@tanstack/react-query'
import { Link, useNavigate } from 'react-router-dom'

function HomePage() {
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.user)
  const stats = { graphicsGeneratedLastMonth: 123 } // Example
  const stores = [{ id: '1', name: 'Sklep Słoneczko', image: skleppng }] // Example

  const { data } = useQuery({
    queryKey: ['advertisementss'],
    queryFn: () => advertisementsService(),
    select: (data) => {
      if (data.success) {
        const currentDate = new Date()
        const firstDayOfMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth(),
          1
        )
        const lastDayOfMonth = new Date(
          currentDate.getFullYear(),
          currentDate.getMonth() + 1,
          0
        )

        return (
          data.data.items?.filter((item) => {
            if (!item.finishedAt) return false
            const finishedAtDate = new Date(item.finishedAt)
            return finishedAtDate >= firstDayOfMonth && finishedAtDate <= lastDayOfMonth
          }) || []
        )
      }
      return undefined
    }
  })

  const handleStoreSelect = () => {
    navigate(paths.GENERATOR)
  }

  return (
    <>
      <Seo title="Witaj | ShopAdverts" />
      <Header hideShopLogo />
      <PageWrap className="flex flex-col items-center justify-start px-2 pt-28 text-center md:px-0">
        <BigContainer>
          <div className="mb-10 space-y-4">
            <h1 className="text-4xl font-bold">
              Witaj, {user?.firstName || 'Użytkowniku'}!
            </h1>
            {stats && (
              <p className="text-lg text-gray-600">
                W tym miesiącu wygenerowałeś/aś{' '}
                <span className="font-semibold text-primary">{data?.length || 0}</span>{' '}
                grafik.
              </p>
            )}
          </div>

          {stores && stores.length > 0 && (
            <div className="mx-auto w-full max-w-md space-y-4">
              <h2 className="text-2xl font-semibold">Wybierz sklep</h2>
              <div className="flex flex-col gap-3">
                {stores.map((store) => (
                  <Button
                    className="h-auto w-full"
                    key={store.id}
                    onClick={() => handleStoreSelect()}
                    variant="outline"
                  >
                    <img
                      alt={store.name}
                      className="h-20 rounded-full object-cover"
                      src={store.image}
                    />
                  </Button>
                ))}
              </div>
              <p className="text-sm text-gray-500">
                Lub{' '}
                <Link className="text-primary hover:underline" to="#">
                  dodaj nowy sklep
                </Link>
                .
              </p>
            </div>
          )}

          <div className="mt-6 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button
              className="w-full px-8 py-3 text-lg sm:w-auto"
              onClick={() => navigate(paths.GENERATOR)}
              size="lg"
            >
              Przejdź do generatora grafik
            </Button>
            <Button
              className="w-full px-8 py-3 text-lg text-primary hover:bg-primary/10 sm:w-auto"
              onClick={() => navigate(paths.GRAPHICS)}
              size="lg"
              variant="ghost"
            >
              Zobacz zapisane grafiki
            </Button>
          </div>
        </BigContainer>
      </PageWrap>
      <Footer />
    </>
  )
}

export default HomePage
